import { withViewModel } from '../../../../infrastructure/components/with-view-model';
import { IHubOrganizationDTO } from '../../../../api/event-hubs.dao';
import { HubOrganizationFormPresentation } from './hub-organization-form-presentation';
import { HubOrganizationFormVM } from './hub-organization-form.viewmodel';

interface IHubOrganizationFormContainerProps {
    accountId: number;
    eventHubId: number;
    updateOrganizationOnList: (organization?: IHubOrganizationDTO) => void;
    closeHubOrganizationPopup?: () => void;
    initialHubOrganization?: IHubOrganizationDTO;
}

const HubOrganizationFormContainer = withViewModel(
    HubOrganizationFormPresentation,
    async (props: IHubOrganizationFormContainerProps) => {
        const hubOrganizationFormVM = new HubOrganizationFormVM(
            props.accountId,
            props.eventHubId,
            props.updateOrganizationOnList,
            props.closeHubOrganizationPopup,
            props.initialHubOrganization,
        );
        await hubOrganizationFormVM.initialize();
        return hubOrganizationFormVM;
    },
    () => []
);

export { HubOrganizationFormContainer as HubOrganizationForm };

